export const PLACEMENTS = 'cart_page.web_rank1|cart_page.web_rank2|cart_page.web_rank3';

export const VARIANT = {
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
};
